var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{attrs:{"id":"num-rows"}},[_vm._v(_vm._s(_vm.totalRows)+" row"),(_vm.totalRows !== 1)?_c('span',[_vm._v("s")]):_vm._e()]),_c('Table',{attrs:{"rows":_vm.rows,"columns":_vm.columns,"selectedColumn":_vm.selectedColumn}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }